export default __webpack_public_path__ + "static/media/keeping-perimeters.e282e3a6.jpg";